module.exports = __webpack_public_path__ + "static/img/home-hero-tablet-bg-02.ad34bbd.svg";